import { p as prisma } from "../../../../../chunks/prisma.js";
const PATCH = async ({ params, request, locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  const body = await request.json();
  const isHex = typeof body.colorHex === "string" && /^#([0-9A-Fa-f]{6})$/.test(body.colorHex);
  if (!body.name || !isHex) return new Response("Bad Request", { status: 400 });
  const cat = await prisma.category.update({ where: { id: params.id }, data: { name: body.name, colorHex: body.colorHex } });
  return new Response(JSON.stringify(cat));
};
const DELETE = async ({ params, locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  await prisma.category.delete({ where: { id: params.id } });
  return new Response(null, { status: 204 });
};
export {
  DELETE,
  PATCH
};
